module.exports = __webpack_public_path__ + "static/media/pending-dispatch.c8190a51.svg";